import { AndroidTVSettingsRepository } from "../../../../data/repository/androidTVSettings/AndroidTVSettingsRepository";
import { Message } from "../../../model/Auth";
import { ResponseState, State } from "../../../model/ResponseState";

export interface AndroidTVSettingsDeleteHomeButtonUseCase {
  invoke: (id: string) => Promise<ResponseState<Message>>;
}

export class AndroidTVSettingsDeleteHomeButtonUseCaseImpl
  implements AndroidTVSettingsDeleteHomeButtonUseCase
{
  private androidTVSettingsRepository: AndroidTVSettingsRepository;

  constructor(androidTVSettingsRepository: AndroidTVSettingsRepository) {
    this.androidTVSettingsRepository = androidTVSettingsRepository;
  }

  async invoke(id: string): Promise<ResponseState<Message>> {
    try {
      let response = await this.androidTVSettingsRepository.deleteHomeButton(
        id
      );
      if (response.isSuccessful) {
        return {
          responseState: State.Success,
          data: response.body!,
        };
      }
      return { responseState: State.Fail, error: response.errorBody! };
    } catch (error) {
      return {
        responseState: State.Error,
        error: { message: String(error), statusCode: 500 },
      };
    }
  }
}
